<div class="d-flex align-items-start" style="margin-bottom: 10px">
    <div style="margin-right: 1rem">
        <person-avatar
            [person]="comment.author"
            [managingOrganisationId]="organisationId"
            [width]="25"
            [height]="25"
        >
        </person-avatar>
    </div>
    <div style="flex-grow: 1">
        <div>
            <strong style="margin-right: 10px"
                >{{ comment.author?.firstName }}
                {{ comment.author?.lastName }}</strong
            >
            <span>{{ comment.modificationTime | formatDateTime }}</span>
        </div>
        <div style="background: #f8f9fa">
            <quill-view
                *ngIf="!isEditing"
                [content]="comment?.content"
                format="object"
            ></quill-view>
            <rich-text-editor
                *ngIf="isEditing"
                [content]="comment?.content"
                [placeholderText]="placeholderText"
                (saveEdit)="onUpdateComment($event)"
                (cancelEdit)="onCancelEdit()"
            ></rich-text-editor>
        </div>
        <ng-container *ngIf="allowEdit">
            <button
                *ngIf="!isEditing"
                class="btn btn-inline btn-inline-primary-action"
                (click)="onEdit()"
            >
                Edit
            </button>
            <button
                *ngIf="!isEditing"
                class="btn btn-inline btn-inline-destructive-action"
                (click)="onDelete()"
            >
                Delete
            </button>
        </ng-container>
    </div>
</div>
